import { Component } from '@angular/core';
import { extend } from 'hammerjs';
import { AbstractNgModelComponent } from '../../base/abstract-ng-model/abstract-ng-model.component';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-bus-seat-search',
  templateUrl: './bus-seat-search.component.html',
  styleUrls: ['./bus-seat-search.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: BusSeatSearchComponent,
    },
  ],
})
export class BusSeatSearchComponent extends AbstractNgModelComponent {
  override value: any = { type: 'username', input: '' };

  override writeValue(v: any): void {
    this.value = v;
  }

  override onChange(): void {
    this.value = this.value;
    this.onFormChange(this.value);
  }
}
